






















































import Vue from 'vue'
import SpiralPath from '@/components/SpiralPath.vue'

export default Vue.extend({
  name: 'app',
  components: {
    SpiralPath
  },
  data: function () {
    return {
      span: 20,
      strokeWidth: 1,
      size: 200,
      initAngle: 0,
      startFromInner: false
    }
  }
})



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/example/SpiralPath.vue